module.exports = __webpack_public_path__ + "media/img/iryo/extra-luggage-3cbad90f583381174e4b1612be5430b0.jpg";